if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;

        // Inputs - These are the corrected selectors
        this.senderInput = this.querySelector(`[name="properties[Gift Certificate From]"]`);
        this.nameInput = this.querySelector(`[name="properties[Recipient Name]"]`);
        this.emailInput = this.querySelector(`[name="properties[Recipient Email]"]`);
        this.messageInput = this.querySelector(`[name="properties[Message]"]`);
        this.sendOnInput = this.querySelector(`[name="properties[Send on]"]`);

        this.errorWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');

        // Form wrapper
        this.productForm = this.closest('form');

        // Event listener
        if (this.productForm) {
          this.productForm.addEventListener('submit', (e) => this.onSubmit(e));
        } else {
          console.warn('Product form not found');
        }
      }

      onSubmit(event) {
        this.clearErrors();
        let valid = true;

        if (!this.senderInput.value.trim()) {
          this.showError(this.senderInput, 'Gift Certificate From is required');
          valid = false;
        }

        if (!this.nameInput.value.trim()) {
          this.showError(this.nameInput, 'Recipient Name is required');
          valid = false;
        }

        const email = this.emailInput.value.trim();
        if (!email) {
          this.showError(this.emailInput, 'Recipient Email is required');
          valid = false;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
          this.showError(this.emailInput, 'Invalid email address');
          valid = false;
        }

        // Message and Send On are now optional — no validation here

        if (!valid) {
          event.preventDefault();
          if (this.errorWrapper) this.errorWrapper.hidden = false;
          return false;
        }

        const controlInput = this.querySelector(`#Recipient-control-${this.sectionId}`);
        if (controlInput) controlInput.value = 'on';
      }

      showError(input, message) {
        const errorEl = input.closest('.recipient-fields__field')?.querySelector('.form__message');
        if (errorEl) {
          errorEl.querySelector('.error-message').innerText = message;
          errorEl.classList.remove('hidden');
        }
      }

      clearErrors() {
        this.querySelectorAll('.form__message').forEach(el => {
          el.classList.add('hidden');
          const msgSpan = el.querySelector('.error-message');
          if (msgSpan) msgSpan.innerText = '';
        });
        if (this.errorWrapper) this.errorWrapper.hidden = true;
      }
    }
  );
}